import React from "react";
import { Container, Button } from "react-bootstrap";

// image
import notFoundImage from "../../images/404.svg";

// meta tag
import MetaTagDecorator from "../../helper/meta_decorator";

export default function NotFoundPage() {
  return (
    <div>
      <MetaTagDecorator
        title="Halaman tidak ditemukan | Pinjam Modal"
        description="Pinjam modal menawarkan solusi modal usaha untuk UMKM online dengan cara mempertemukan peminjam dan pendana lewat platform aplikasi pinjaman online; Pinjam Modal."
      />
      <div className="py-4">
        <Container style={{ textAlign: "center" }}>
          <h2 className="py-2 tblue">Error 404</h2>
          <img
            src={notFoundImage}
            style={{ maxWidth: "500px", width: "100%" }}
            alt="not-found"
          />
          <h2 className="pt-5 pb-4">
            <b>Halaman yang Anda cari tidak ditemukan</b>
          </h2>
          <a href="/">
            <Button
              type="button"
              style={{ backgroundColor: "#007edc", color: "#fff" }}
              className="py-3 px-5 mb-4"
            >
              KEMBALI
            </Button>
          </a>
        </Container>
      </div>
    </div>
  );
}
